import React, { Component } from 'react';
import axios from 'axios';

import '../css/contactos.css'

import fotofondo from '../img/foto-contactos.jpg'
import facebook from '../img/facebook-ico.svg'
import twitter from '../img/twitter-ico.svg'
import politica from '../img/politicadato.jpeg'

// import whatsapp from '../img/whatsapp-ico.svg'

const API_PATH = 'http://ferreteriapadilla.com/api/contact/index.php';

const stateInicial = {
  fname: '',
  email: '',
  message: '',
  mailSent: false,
  error: null
 }

class Contactos extends Component {
  state = { ...stateInicial  }

  handleChange = e => {
    this.setState({
      ...this.state,
      [e.target.name] : e.target.value
    })
  }

  handleSubmit = e => {
    e.preventDefault();
    axios({
      method: 'post',
      url: `${API_PATH}`,
      headers: { 'content-type': 'application/json' },
      data: this.state
    })
    .then(result=>{ this.setState({
      mailSent: result.data.sent
    })
    })
    .catch(error=>this.setState({ error:error.message }));

    this.setState({
        ...stateInicial
    })
  };

  render() {
    return (
      <div className="container mt-4">

        <div className="row no-gutters">

          <div className="contactostexto col-12 col-lg-6">
            <div className="contactosfondo">
              <img className="img-fluid" src={fotofondo} alt=""/>
            </div>
          </div>

          <div className="contactosform container col-12 col-lg-6 p-5">
            <div className="row no-gutters">

              <div className="contactostitulo pb-3 col-12">Contáctanos Ya</div>
                            <div className="col-12">
                <form onSubmit={this.handleSubmit}>

                  <div className="form">
                    <div>
                      <input id="fname" type="text" className="nombre form-control" placeholder="Nombre"
                        name="fname"
                        value={this.state.fname}
                        onChange={this.handleChange}
                        required
                      />
                      <input id="email" type="email" className="email form-control mt-2" placeholder="Email"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        required
                      />
                      <textarea id="message" class="mensaje form-control mt-2" rows="3" placeholder="Mensaje"
                        name="message"
                        onChange={this.handleChange}
                        value={this.state.message}
                        required
                      ></textarea>
                    </div>
                  </div>

                  <div className="container mt-2">
                    <div className="row justify-content-between">
                      <div className="col-auto nav">
                        <div><a href="https://www.facebook.com/Ferrepadillaecu" target="_blank"><img className="redes efectohover" src={facebook} alt="yy"/></a></div>
                        <div><a href="https://twitter.com/ferrepadilla" target="_blank"><img className="redes efectohover" src={twitter} alt=""/></a></div>
                        <div><a href="https://1drv.ms/b/s!AvzCqKZi5FNorCkNa3WTpIEwL2sp?e=ZL5MZs" target="_blank"><img className="redes efectohover" src={politica} alt=""/></a></div>
                        {/* <div><a href="https://api.whatsapp.com/send?phone=593993185592" target="_blank"><img className="redes efectohover" src={whatsapp} alt=""/></a></div> */}
                      </div>
                      <div className="col-auto">
                        <button type="submit" value="Submit" class="btn btn-dark mt-2">Enviar</button>
                      </div>
                    </div>
                  </div>

                </form>
                <div className="mensajeerror">

                  {this.state.mailSent && <div>Gracias por contactarnos.</div>}
                  {this.state.error && <div className="error">Algo salio mal. Intente nuevamente.</div>}

                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    )
  }
}

export default Contactos;
